import React, { Component } from 'react';
import Question from './Question.jsx';
import QuestionLDC from './QuestionLDC.jsx';
import Or from './Or.jsx';
import Calculation from './Calculation.jsx';
import converter from './Converter';
import {
	parseCondition,
	conditionCheckFunction,
	removeDuplicates,
	parseForumla,
	getVar,
	getVarFromDropDwon,
	groupBy
} from './ConfigFunction'

import { unitApp } from './unitApp'
import { translate } from "react-translate";

import ModalExport from './ModalExport'
import ModalHistorique from './ModalHistorique'
import ModalAddToList from './ModalAddToList'
import ModalLoader from './ModalLoader'

import { Link, Route } from 'react-router-dom'

import imageExport from '../../../assets/img/exporter.png';
import imageHistory from '../../../assets/img/history.png';
import imageQuestion from '../../../assets/img/question.png';

//IMPORT SEMANTIC COMPONENTS
import 'semantic-ui-css/semantic.min.css';
import {
	Grid,
	Segment,
	Item,
	Form,
	Button,
	Container,
	Divider,
	Icon,
	Modal,
	Header,
	Image,
	Loader,
	Label,
	Popup
} from 'semantic-ui-react';

// REDUX Maxence
import { connect } from 'react-redux';
import {
	addModalExport,
	addModalHistorique,
	addModalAddToList,
	addToList,
	addCalculResult,
	addCalculHistorique,
	addList,
	addArticle,
	addAtlError,
	addCalculError,
	addHowToLink,
	addHowToText,
	addWorkTile,
	addWorkDescription,
	addModalLoader
} from '../../../redux/actions/ConfigFileAction'

import { addContactInfo } from '../../../redux/actions/AppAction';

import API from '../../../services/api';

import './Work.css'

import _ from 'lodash';

const proExtensionID = 3;

var FormulaParser = require('hot-formula-parser').Parser;

const mapStateToProps = state => ({
	app: state.app,
	configfile: state.configfile,
	user: state.user
})

const mapActionToProps = {
	addModalExport: addModalExport,
	addModalHistorique: addModalHistorique,
	addModalAddToList: addModalAddToList,
	addToList: addToList,
	addCalculResult: addCalculResult,
	addCalculHistorique: addCalculHistorique,
	addList: addList,
	addArticle: addArticle,
	addAtlError: addAtlError,
	addCalculError: addCalculError,
	addHowToLink: addHowToLink,
	addHowToText: addHowToText,
	addWorkTile: addWorkTile,
	addWorkDescription: addWorkDescription,
	addModalLoader: addModalLoader,
	addContactInfo : addContactInfo
}

class ConnectedWork extends Component{
  constructor(props) {
    super(props)

    this.state = ({
      group: [],
      histoSelect: false,
      raz: false,
      unitApp: unitApp,
      modal_loader: false,
			groupQuestion: {},
			configFileLang: this.props.configFileLang,
			pro: this.props.pro ? true : false,
			preentries : {},
    })

		this.handleCalcul = this.handleCalcul.bind(this);
		this.handleRaz = this.handleRaz.bind(this);
		this.handleAddToList = this.handleAddToList.bind(this);
		this.handleAddCalc = this.handleAddCalc.bind(this);

		// Callback functions
		this.handleChangeValueOfQuestionLDC = this.handleChangeValueOfQuestionLDC.bind(this)
		this.handleChangeValueOfQuestion = this.handleChangeValueOfQuestion.bind(this)
		this.handleChangeUnitOfQuestion = this.handleChangeUnitOfQuestion.bind(this)
		this.handleChangeValueOfCalculation = this.handleChangeValueOfCalculation.bind(this)
		this.handleChangeUnitOfCalculation = this.handleChangeUnitOfCalculation.bind(this)
		this.handleChangeCalcHistoryCallback = this.handleChangeCalcHistoryCallback.bind(this)
		this.gotoContactAndPrefill = this.gotoContactAndPrefill.bind(this);

		// Bind Redux
		this.openModalExport = this.openModalExport.bind(this)
		this.openModalHisto = this.openModalHisto.bind(this)
		this.openModalAddToList = this.openModalAddToList.bind(this)
		this.addToList = this.addToList.bind(this)
		this.addCalculResult = this.addCalculResult.bind(this)
		this.addList = this.addList.bind(this)
		this.addArticle = this.addArticle.bind(this)
		this.closeModalLoader = this.closeModalLoader.bind(this)

		// Set Redux variables
		this.addHowToLink()
		this.addHowToText()
		this.addWorkTile()
		this.addWorkDescription()

		var calculationData = []
	}

	// MODAL functions
	openModalExport() {
		this.props.addModalExport(true)
	}
	openModalHisto() {
		this.handleCalcHisto()
		this.props.addModalHistorique(true)
	}
	openModalAddToList() {
		this.props.addModalAddToList(true)
	}

	openModalLoader() {
		this.props.addModalLoader(true)
	}
	closeModalLoader() {
		this.props.addModalLoader(false)
	}

	//Redux
	addToList(atl) {
		this.props.addToList(atl)
	}

	addAtlError(atlError) {
		this.props.addAtlError(atlError)
	}

	addCalculError(calculError) {
		this.props.addCalculError(calculError)
	}

	addCalculResult(calculResult) {
		this.props.addCalculResult(calculResult)
	}

	addCalculHistorique(calculHisto) {
		this.props.addCalculHistorique(calculHisto)
	}

	addList(list) {
		this.props.addList(list)
	}

	addArticle(article) {
		this.props.addArticle(article)
	}

	addHowToLink() {
		this.props.addHowToLink(this.props.howToLink)
	}
	addHowToText() {
		this.props.addHowToText(this.props.howToText)
	}
	addWorkTile() {
		this.props.addWorkTile(this.props.workTitle)
	}
	addWorkDescription() {
		this.props.addWorkDescription(this.props.description)
	}

	initializeWorkFromProps() {
		let group = {}

		Object.entries(this.props.group).map((key, Mainindex) => {
			if ((key[1].OR === undefined && key[1]["Question LDC"] === undefined &&
					key[1].Question === undefined && key[1].Calculation === undefined)) {

			} else if (key[1].Order !== undefined) {
				let order = key[1].Order
				group[order] = key[1]
			}
		})

		// Initialize calculation data
		this.calculationData = this.initializeCalculationData(group)
		let groupQuestion = {}
		//ORDER THE QUESTIONS
		groupQuestion = this.orderingQuestions(group)
		this.setState({
			group: group,
			configFileLang: this.props.configFileLang,
			groupQuestion: groupQuestion,
		}, () =>
		this.checkHide())
	}

	componentWillMount() {
		// Checking pro extension
		var subData = {
			id: this.props.app.id
		}
		API.getSub(this.props.app.token, subData).then((res) => {
			let subs = []
			if (res && res.data && res.data.subs) {
				Object.entries(res.data.subs).map((key) => {
					Object.entries(key[1]).map((item, mainindex) => {
						if (item[0] === "pkuidsub") {
							subs.push(key[1].pkuidsub)
						}
					})
				});
			}
			var isPro = _.indexOf(subs, proExtensionID) !== -1 ;
			this.setState({
					isPro: isPro,
			});
	});

		document.getElementsByTagName('body')[0].scrollTop = 200;
		this.initializeWorkFromProps()
		// Calling RAZ on component mount to clear error/calculation/field data (it also prefills again the preentries)
		this.handleRaz({preventDefault: () => {}});
	}

	createNewOperand() {
		let value = {
			ID: null,
			groupid: null,
			order: null,
			text: null,
			unit: null,
			unitApp: null,
			value: null,
			variable: null,
			error: null,
			textChoose: null,
			variableNum: null,
			variableTextValue: null,
			currency: null,
			preentry: null,
			information: null,
			raz: null,
			unitSent: null,
			userUnit: null,
			unitSet: null,
			valueType: null,
			colorBlue: null,
			options: null,
			error: null,
			result: null,
			formula: null,
			condition: null
		};

		value.userUnit = this.props.unit;
		value.currency = this.props.currency;
		value.userUnit = this.props.unit;
		value.lang = this.props.lang;

		return value;
	}

	getQuestionValue(question, groupID) {
		let value = this.createNewOperand();
		value.valueType = "Question";

		value.ID = question.ID;
		value.order = question.Order;
		value.groupid = groupID;

		if (question.Text) {
			Object.entries(question.Text).map((key, Mainindex) => {
				if (key[0] === this.props.lang) {
					value.text = key[1]
				}
			})
		}

		if (question.Unit) {
			Object.entries(question.Unit).map((key, Mainindex) => {
				if (key[0] === "Meter") {
					value.unitSet = key[1]
				}
			})
		}

		if (question.Preentry != undefined) {
			value.preentry = question.Preentry
		}

		if (question.Variable != undefined) {
			value.variable = question.Variable
		}

		if (question.ColorBlue) {
			value.colorBlue = question.ColorBlue
		}

		if (question.Informations) {
			Object.entries(question.Informations).map((key, Mainindex) => {
				if (key[0] === this.props.lang) {
					value.information = key[1]
				}
			})
		}

		if (this.state.raz) {
			value.raz = this.state.raz
		}

		if (this.props.configfile.calculResult != undefined ||
			this.props.configfile.calculResult != null) {
			Object.entries(this.props.configfile.calculResult).map((key, Mainindex) => {
				if (key[1].variable === question.variable) {
					value.preentry = question.value
					value.unitSend = question.unitSet
				}
			})
		}

		value.value = this.convertStringToDigit(value.preentry)

		if (value.unitSet !== undefined && value.unitSet !== null) {
			let uniqUnit, appUnit
			let unitTmp = value.unitSet.replace(new RegExp("%%", 'g'), '').split(';')

			if (value.userUnit === "Meter") {
				uniqUnit = unitTmp[2]
			} else {
				uniqUnit = unitTmp[3]
			}

			// if (this.state.unitSend != null) {
			// 	uniqUnit = this.state.unitSend
			// }
			appUnit = unitTmp[1]
			value.unit = uniqUnit
		}

		return value;
	}

	getORValue(or, groupID) {
		let value = this.createNewOperand();
		value.valueType = "OR";
		value.text = "OR";
		return value;
	}

	getQuestionLdcValue(questionLDC, groupID) {
		let value = this.createNewOperand();
		value.valueType = "Question LDC";

		value.ID = questionLDC.ID;
		value.order = questionLDC.order;
		value.groupid = groupID;

		if (questionLDC.Text != undefined) {
			Object.entries(questionLDC.Text).map((key, Mainindex) => {
				if (key[0] === this.props.lang) {
					value.text = key[1]
				}
			})
		}

		if (questionLDC.Unit) {
			Object.entries(questionLDC.Unit).map((key, Mainindex) => {
				if (key[0] === "Meter") {
					value.unit = key[1]
				}
			})
		}

		if (questionLDC.ColorBlue) {
			value.colorBlue = questionLDC.ColorBlue
		}

		if (questionLDC.Preentry) {
			value.preentry = questionLDC.Preentry
		}

		if (questionLDC.Informations) {
			Object.entries(questionLDC.Informations).map((key, Mainindex) => {
				if (key[0] === this.props.lang) {
					value.information = key[1]
				}
			})
		}

		if (this.state.raz) {
			value.raz = this.state.raz
		}

		if (this.props.configfile.calculResult != undefined ||
			this.props.configfile.calculResult != null) {
			Object.entries(this.props.configfile.calculResult).map((keys, Mainindex) => {
				if (keys[1].VariableNum === questionLDC.VariableNum ||
					keys[1].variableText === questionLDC.VariableText) {
					value.preentry = keys[1].variableTextValue
				}
			})
		}

		if (value.preentry !== null) {
			value.value = this.convertStringToDigit(value.preentry)
		}

		value.variableNum = questionLDC.variableNum;
		value.variableText = questionLDC.variableText;
		value.options = questionLDC.LDC;

		return value;
	}


	getCalculationValue(calculation, groupID) {
		let value = this.createNewOperand();

		value.valueType = "Calculation";
		value.ID = calculation.ID;
		value.order = calculation.order;
		value.groupid = groupID;

		if (calculation.Condition !== undefined && calculation.Condition !== null) {
			// RETURN CALCULATION
			let variable, result, raz, information, error;

			if (calculation.Text) {
				Object.entries(calculation.Text).map((key, Mainindex) => {
					if (key[0] === this.props.lang) {
						value.text = key[1]
					}
				})
			}
			if (calculation.Unit) {
				Object.entries(calculation.Unit).map((key, Mainindex) => {
					if (key[0] === "Meter") {
						value.unit = key[1]
					}
				})
			}

			if (calculation.Variable != undefined) {
				value.variable = calculation.Variable
			}

			if (this.props.configfile.calculResult != undefined ||
				this.props.configfile.calculResult != null) {
				Object.entries(this.props.configfile.calculResult).map((key, Mainindex) => {
					if (key[1].variable === value.variable) {
						value.result = key[1].value
						value.unitSend = key[1].unit === undefined ? '' : key[1].unit
					}
				})
			}

			if (calculation.Informations) {
				Object.entries(calculation.Informations).map((key, Mainindex) => {
					if (key[0] === this.props.lang) {
						value.information = key[1]
					}
				})
			}

			if (this.state.raz) {
				value.raz = this.state.raz
			}

			value.order = calculation.Order
			value.formula = calculation.Formula
			value.condition = calculation.Condition
		}

		return value;
	}


	initializeCalculationData(group) {
		let vars = [];
		//ORDER THE QUESTIONS
		Object.entries(group).map((key, Mainindex) => {
			let groupID = (parseInt(key[1].GroupID) - 1) + '';
			let order = key[1].Order;
			Object.entries(key[1]).map((key, Mainindex) => {
				switch (key[0]) {
					case "Question":
						Object.entries(key[1]).map((key, Mainindex) => {
							let questionValue = this.getQuestionValue(key[1], groupID);
							vars.push(questionValue);
						});
						break;
					case "Question LDC":
						Object.entries(key[1]).map((key, Mainindex) => {
							let questionLDCValue = this.getQuestionLdcValue(key[1], groupID);
							vars.push(questionLDCValue);
						});
						break;
					case "Calculation":
						Object.entries(key[1]).map((key, Mainindex) => {
							let calculationValue = this.getCalculationValue(key[1], groupID);
							vars.push(calculationValue);
						});
						break;
				}
			})

		})

		return vars;
	}

	traceError(calculationItem) {
		/* Check input error and set error into the question/ldc items */
		// Get variables of question / ldc
		let strFormula = calculationItem.formula.Meter
		let startPosition = 'ROUNDUP('.length
		let endPosition = strFormula.lastIndexOf(';')
		let strSubFormula = strFormula.substring(startPosition, endPosition);
		let variableList = strSubFormula.match(/[a-z]+/g)

		// Check input value, and set error if no value
		if (variableList) {
			Object.entries(variableList).map((variable, variableIndex) => {
				Object.entries(this.calculationData).map((item, index) => {
					let itemVariable
					switch (item[1].valueType) {
						case "Question":
						case "Calculation":
							itemVariable = item[1].variable
							break
						case "Question LDC":
							itemVariable = item[1].variableNum
							break
					}

					if (itemVariable === variable[1] &&
							(!item[1].value || item[1].value === 'Erreur')) { // && (item[1].ID !== calculationItem.ID)
						// Set error into calculationData
						item[1].error = calculationItem.error
						// Set error into question/ldc item
						this.setErrorQuestionGroupItem(item[1].groupid, item[1].ID, item[1].order, calculationItem.error)
						// Re-call to trace rest error
						if (item[1].valueType === 'Calculation') {
							this.traceError(item[1])
						}
					}
				})
			})
		}
	}

	handleAddCalc(e, variable) {
		e.preventDefault();

		var form = new FormData();
		form.append("fkuiduser", this.props.app.id);
		form.append("fkuidworks", this.props.workId);
		form.append("source", "mtf");
		form.append("variable", variable);
		API.createHisto(this.props.app.token, form).then((res) => {
			//Saved histo
		});

	}

	handleCalcHisto() {
		var self = this;
		var histoData = {
			fkuiduser: this.props.app.id,
			fkuidworks: this.props.workId
		};
		API.getAllHisto(this.props.app.token, histoData).then((res) => {
			this.addCalculHistorique(res.data);
		});
	}

	//Hande calcul
	handleCalcul(e, groupQuestion, boolSave) {
		//Contains all the var letters and value
		this.setState({
			modal_loader: true
		})
		// let vars = []

		//Not use yet
		let varResult = []
		// this.calculationData = this.initializeWorkFromProps()
		// vars = this.calculationData;
		let error = false;
		Object.entries(groupQuestion).map((key, Mainindex) => {
			Object.entries(key[1]).map((key, Mainindex) => {
				key[1].Error = null
				if (key[1].Condition != undefined) {
					let variableResult = key[1].Variable
					let conditionCheck = conditionCheckFunction(key[1].Condition, this.calculationData)

					if (conditionCheck) {
						//Condition ok , continue with formula
						let formula = key[1].Formula['Meter']
						let tmp = parseForumla(formula, this.calculationData, key[1].Variable)

						Object.entries(this.calculationData).map((calculationItem, Mainindex) => {
							calculationItem[1].error = null
							if (calculationItem[1].variable == variableResult) {

								if (tmp['error'] !== null) {
									calculationItem[1].value = "Erreur"
									error = true
								} else {
									calculationItem[1].value = Math.abs(tmp['result'])
								}

								calculationItem[1].error = tmp['error']

								if (calculationItem[1].error) { // &&  (calculationItem[1].valueType === 'Question' ||  calculationItem[1].valueType === 'Question LDC')
									this.traceError(calculationItem[1])
								}
							}
						})
					}
				}
			})
		})

		if (boolSave && !error) {
			this.handleAddCalc(e, JSON.stringify(this.calculationData))
		}

		if (error) {
			this.addToList(true);
			this.addCalculResult(this.calculationData);
			this.addCalculError(true);
		} else {
			this.addToList(true);
			this.addCalculResult(this.calculationData);
			this.addCalculError(false);
		}

		this.setState({
			modal_loader: false
		})
	}

	checkHide() {
		let group = this.state.groupQuestion
		Object.entries(group).map((key, Mainindex) => {
			Object.entries(key[1]).map((key, Mainindex) => {
				if (key[1].Hide) {
					if (conditionCheckFunction(key[1].Hide, this.calculationData)) {
						key[1].IsHidden = true
					} else {
						key[1].IsHidden = false
					}
				}
				if (key[1].IsHidden === false && key[1].CanHideOptions) {
					key[1].LDC = []
					for (let i = 0 ; key[1].AllLDC.length > i ; i++) {
						if (key[1].AllLDC[i].Hide) {
							if (!conditionCheckFunction(key[1].AllLDC[i].Hide, this.calculationData)) {
								key[1].LDC.push(key[1].AllLDC[i])
							}
						} else {
							key[1].LDC.push(key[1].AllLDC[i])
						}
					}
				}
			})
		})

		this.setState({
			groupQuestion: group
		})
	}

	handleAddToList(e) {
		e.preventDefault();
		let conditionCheck;
		let vars = [];
		let article = []
		let error;

		this.props.addToListCondition.map(
			key => Object.entries(key).map((key, Mainindex) => {

				if (key[0] === "ErrorCondition") {
					vars = this.calculationData;
					conditionCheck = conditionCheckFunction(key[1], vars);
					error = false
				}

				if (!conditionCheck && key[0] === "ToWishlist") {
					error = false

					key[1].map(
						key => {
							let conditionArticle = conditionCheckFunction(key.Condition, vars)

							if (conditionArticle) {
								let pkuidga, pkuida, ManualText
								if (key.PKUIDGA != undefined) {
									pkuidga = key.PKUIDGA;
								}
								if (key.PKUIDA != undefined) {
									pkuida = key.PKUIDA;
								}
								if (key.ManualText != undefined) {
									ManualText = key.ManualText;
								}
								let price = key.Price;
								let quantity = key.Quantity;
								vars.map(
									key => {
										if (key.variable === price || key.variableNum === price) {
											price = key.value
										}
										if (key.variable === quantity || key.variableNum === quantity) {
											quantity = key.value
										}
									}
								)

								let tmp = {}
								tmp.pkuidga = pkuidga
								tmp.pkuida = pkuida
								tmp.manual = ManualText
								tmp.price = price
								tmp.quantity = parseInt(quantity)

								article.push(tmp)
							}
						}
					)

					var listData = {
						fkuiduser : this.props.app.id
					};
					API.getList(this.props.app.token, listData).then((res) => {
						this.addToList(true);
						this.addList(res.data.lists);
						this.addArticle(article);
						this.openModalAddToList();
						this.addAtlError(false);
						this.addCalculError(false);
					});
				}
				else {
					if (key[0] === "ErrorMessage") {
						Object.entries(key[1]).map((key, Mainindex) => {
							if (key[0] === this.props.lang) {
								error = key[1] + ". "
							}
						})
					}
				}
			})
		)

		if (error) {
			this.addToList(false);
			this.addAtlError(error);
			this.addCalculError(true);
		}
	}


	handleRaz(e) {
		e.preventDefault();

		this.addToList(false);
		this.addCalculResult({});
		this.addAtlError(true);

		this.addCalculError(false);

		this.setState({
			raz: true
		})

		this.initializeWorkFromProps()
	}

	findCalculationData(groupID, operandID, orderID) {
		for(var i = 0; i < this.calculationData.length; i ++) {
			var data = this.calculationData[i]
			if (parseInt(data.groupid) === parseInt(groupID) &&
					(parseInt(data.ID) === parseInt(operandID))) {
				if (data.order === undefined) {
					return i
				} else if (parseInt(data.order) === parseInt(orderID)) {
					return i;
				}
			}
		}
		return -1;
	}

	setErrorQuestionGroupItem(groupID, operandID, orderID, error) {
		Object.entries(this.state.groupQuestion).map((group, groupIndex) => {
			Object.entries(group[1]).map((item, index) => {
				if ((parseInt(item[1].GroupID) - 1 + '') === groupID &&
						item[1].ID === operandID &&
						item[1].Order === orderID) {
					item[1].Error = error
				}
			})
		})

	}

	handleChangeValueOfQuestionLDC(groupID, operandID, orderID, changedValue) {
		let operandIndex = this.findCalculationData(groupID, operandID, orderID);
		if (operandIndex > -1) {
			let variableNumValue = parseInt(changedValue.variableNumValue, 10)
			let operand =  this.calculationData[operandIndex]
			let foundOptions = _.filter(operand.options, ['LDCId', changedValue.value]);
			if(foundOptions.length > 0 && foundOptions[0].LinkId){
				let foundOption = foundOptions[0];
				var groupArticleData = {
					lang: this.props.app.lang,
					pkuidga: foundOption.LinkId,
				};

				API.findGroupArticleById(this.props.app.token, groupArticleData).then((res) => {
					if(res.data && res.data.code === 200 && res.data.groupArticles && res.data.groupArticles.length > 0 ) {
						var attr = foundOption.LinkAttribute ? foundOption.LinkAttribute.toLowerCase() : 'spmoy';
						var toDisplay = res.data.groupArticles[0][attr] || '0';
						var allGroupQuestionCopy = _.cloneDeep(this.state.groupQuestion);
						var groupQuestion = allGroupQuestionCopy[groupID];
						groupQuestion[orderID].Value = changedValue.value;
						Object.entries(groupQuestion).map((qObjectEntry) => {
							var obj = qObjectEntry[1];
							if(obj.Preentry !== '%' + operandID + '%'){
								return;
							}
							// Found corresponding input, changing its displayed value
							obj.Value = toDisplay;
							// Updating calculation data with new input value
							let operandIndex = this.findCalculationData(groupID, obj.ID, obj.Order)
							if (operandIndex > -1) {
								let operand = this.calculationData[operandIndex]
								operand.value = this.convertStringToDigit(changedValue.value)
								operand.unitApp = changedValue.unitApp
								this.calculationData[operandIndex] = operand
							}
						});
						// Anyway we update state with new groupQuestion (select change (mandatory) + input change (optional, only if preentry found) )
						this.setState({
							groupQuestion : allGroupQuestionCopy
						})
					} else {
					// GA not found, we just update the select change
						var allGroupQuestionCopy = _.cloneDeep(this.state.groupQuestion);
						if(allGroupQuestionCopy && allGroupQuestionCopy[groupID] && allGroupQuestionCopy[groupID][operandID]) {
							allGroupQuestionCopy[groupID][operandID].Value = changedValue.value;
							this.setState({
								groupQuestion : allGroupQuestionCopy
							})
						}
					}
				});
			}

			operand.value = this.convertStringToDigit(changedValue.value);
			operand.variableNum = changedValue.variableNum;
			operand.variableText = changedValue.variableText;
			operand.variable = changedValue.variable;
			operand.variableNumValue = changedValue.variableNumValue;
			operand.order = changedValue.order;
			operand.variableTextValue = changedValue.variableTextValue;
			operand.unitApp = changedValue.unitApp;
			operand.text = changedValue.text;
			operand.textChoose = changedValue.textChoose;

			this.calculationData[operandIndex] = operand;

			this.checkHide()
		}
	}

	convertStringToDigit(stringValue) {
		let parsedValue

		if (typeof stringValue === 'string') {
			if (stringValue.indexOf(',') > -1 ||
					stringValue.indexOf('.') > -1) {
				parsedValue = parseFloat(stringValue.replace(',', '.'))
			} else {
				parsedValue = parseInt(stringValue)
			}
		} else {
			parsedValue = stringValue
		}

		if (isNaN(parsedValue)) {
			parsedValue = 0;
		}

		return parsedValue
	}

	handleChangeValueOfQuestion(groupID, operandID, orderID, changedValue) {
		// Mutating groupQuestion state directly and calling setState immediatly to forceUpdate.
		if(this.state.groupQuestion && this.state.groupQuestion[groupID] && this.state.groupQuestion[groupID][orderID|| operandID]) {
			this.state.groupQuestion[groupID][orderID || operandID].Value = changedValue.value;
			this.setState({
			});
		}

		// Then we update our calculation data
		let operandIndex = this.findCalculationData(groupID, operandID, orderID)
		if (operandIndex > -1) {
			let operand = this.calculationData[operandIndex]
			operand.value = this.convertStringToDigit(changedValue.value)
			operand.unitApp = changedValue.unitApp
			this.calculationData[operandIndex] = operand

		}
	}

	handleChangeUnitOfQuestion(groupID, operandID, orderID, changedValue) {
		let operandIndex = this.findCalculationData(groupID, operandID, orderID);

		if (operandIndex > -1) {
			let operand = this.calculationData[operandIndex]

			operand.value = changedValue.value
			operand.unit = changedValue.unit

			this.calculationData[operandIndex] = operand
		}
	}

	handleChangeValueOfCalculation(groupID, operandID, orderID, changedValue) {
		let operandIndex = this.findCalculationData(groupID, operandID, orderID);

		if (operandIndex > -1) {
			let operand = this.calculationData[operandIndex]

			operand.value = parseFloat(changedValue.value);
			operand.order = changedValue.order,
			operand.condition = changedValue.condition,
			operand.formula = changedValue.formula,
			operand.unit = changedValue.selectedUnit,
			operand.unitApp = changedValue.unitApp,
			operand.raz = changedValue.raz,
			operand.text = changedValue.text

			this.calculationData[operandIndex] = operand
		}
	}

	handleChangeUnitOfCalculation(groupID, operandID, orderID, changedValue) {
		let calculationIndex = this.findCalculationData(groupID, operandID, orderID)

		if (calculationIndex > -1) {
			let calculation = this.calculationData[calculationIndex]

			calculation.value = changedValue.value
			calculation.unit = changedValue.unit

			this.calculationData[calculationIndex] = calculation
		}
	}

	handleChangeCalcHistoryCallback(historyContent) {
		this.calculationData = historyContent
	}

	componentDidMount() {
		if (this.state.raz) {
			this.setState({
				raz: false
			})
		}
	}

	componentDidUpdate() {
		if (this.state.raz) {
			this.setState({
				raz: false
			})
		}
	}

	makePathTag(path = []) {
		var parentsTag = path[0];
		for (var i = 1; i < path.length - 1; i++) {
			parentsTag = parentsTag + " / " + path[i];
		}

		return (
			<Label className='topbar-path'>
				<a id="menuTextTopRight" onClick={this.props.prevPathCallback}
					className="topbar-path-previous-link">
					{parentsTag}
				</a>
				<span className="topbar-slash">{" / "}</span>
				<span className="topbar-path-current">
					{path[path.length - 1]}
				</span>
			</Label>
		)
	}

	orderingQuestions(group) {
		let questions = {}
		let groupQuestion = {}

		//ORDER THE QUESTIONS
		Object.entries(group).map((groupKey, Mainindex) => {

			Object.entries(groupKey[1]).map((key, Mainindex) => {
				switch (key[0]) {
					case "Question LDC":
						Object.entries(key[1]).map((key, Mainindex) => {
							if (key[1].LDC.filter(option => option.Hide).length > 0) {
								key[1].CanHideOptions = true
							} else {
								key[1].CanHideOptions = false
							}
						})
					case "Question":
					case "OR":
					case "Calculation":
						Object.entries(key[1]).map((key, Mainindex) => {
							key[1].Error = null
							key[1].IsHidden = false
							key[1].AllLDC = key[1].LDC
							questions[key[1].Order] = key[1]
							questions[key[1].Order]['GroupID'] = groupKey[1].GroupID
						})
						break;
				}
			})

			groupQuestion[Mainindex] = questions
			questions = {}
		})

		return groupQuestion;
	}

	getGroupID(question) {
		return parseInt(question.GroupID) - 1
	}

	createOnlyQuestionsGroupTag(questions) {
		return (
			<Segment.Group key={0} horizontal className='only-question-group'>
				<Grid doubling className='questions-container-grid'>
					<Grid.Column className='only-questions-container-column' mobile={16} computer={16}>
						<Segment className='only-questions-wrapper'>
							{questions}
						</Segment>
					</Grid.Column>
				</Grid>
			</Segment.Group>
		)
	}

	createOnlyCalculationsGroupTag(calculations) {
		return (
			<Segment.Group key={0} horizontal className='only-calculations-group'>
				<Grid doubling className='only-calculations-container-grid'>
					<Grid.Column mobile={16} width={11}>
						<Segment className='only-calculations-wrapper'>
							{calculations}
						</Segment>
					</Grid.Column>

					<Grid.Column textAlign="left" verticalAlign="middle" mobile={16} width={5}>

					</Grid.Column>
				</Grid>
			</Segment.Group>
		)
	}

	gotoContactAndPrefill(history) {
		let token = localStorage.getItem('USER_TOKEN');
		var base64Url = token.split('.')[1];
		var base64 = base64Url.replace('-', '+').replace('_', '/');
		var tmp = JSON.parse(window.atob(base64));
		let mail = tmp['username'];
		API.getUser(this.props.app.token).then((res) => {

			var calcDataMessage = "Calculation Data :\n";
			if(this.calculationData) {
				for(var i = 0; i < this.calculationData.length; i++){
					let data = this.calculationData[i];
					calcDataMessage += data.text + ": " + data.value + (data.unit ? data.unit : '') + "\n" ;
				}
			}

			var message = 'Bonjour,\nJ\'ai identifié cette erreur :\n\n\n\n'
			+ 'Erreur sur le type de  travaux : ' + this.props.workTitle + '\n\n'
			+ '---------------\n'
			+ 'Nom d\' utilisateur: ' + res.data.fullname + '\n'
			+ 'Email: ' + mail + '\n'
			+ 'Ref Utilisateur (id) :' + tmp['id'] + '\n'
			+ '---------------\n'
			+ calcDataMessage
			+ '---------------\n';

			this.props.addContactInfo({
				email: mail,
				message: message,
				name : res.data.fullname
			});
			history.push('/contact')
		});
	}

	render() {
		if (this.props.configFileLang != this.state.configFileLang) {
		 	this.componentWillMount()
		}

		var errorMessageLogin = {
			display:  'flex',
			justifyContent:  'center',
			alignItems:  'center',
			fontSize: '1.2em'
		}
    const { t } = this.props
		const { pro } = this.state
		return (
			<div className="topbar-container">
				{/* Path && two buttons */}
				<Grid doubling className='topbar-container-grid'>
					<Grid.Row columns={3} className={pro ? 'topbar-container-row-pro' : 'topbar-container-row'}>
						<label className={pro ? 'topbar-label-pro' : 'topbar-label'}>{t('pro')}</label>


						<Grid.Column textAlign='left' verticalAlign='middle' mobile={16} tablet={4} computer={4} className="topbar-col">
							{this.makePathTag(this.props.prevPath)}
						</Grid.Column>

						<Grid.Column textAlign='right' verticalAlign='middle' mobile={16} tablet={12} computer={12} className="topbar-col">

						{/*<div class="">*/}
							<ModalExport />
							<Button onClick={this.openModalExport} circular className='topbar-button' size="small" floated="right">
								<Image src={imageExport} size='mini' verticalAlign='middle'
									className='topbar-button-image' />
								<Label className='topbar-button-caption'>
									{t("export")}
								</Label>
							</Button>
						{/*</div>*/}

						{/*<div class="">*/}
							<ModalHistorique onChangeCalcHistoryCallback={this.handleChangeCalcHistoryCallback}/>
							<Button onClick={this.openModalHisto} circular className='topbar-button' size="small" floated="right">
								<Image src={imageHistory} size='mini' verticalAlign='middle'
									className='topbar-button-image' />
								<Label className='topbar-button-caption'>
									{t("historique")}
								</Label>
							</Button>
						{/*</div>*/}

						{/* <div class="">*/}
							<Route render={({history}) => (
									<Button onClick={() => this.gotoContactAndPrefill(history)} circular className='topbar-button' size="small" floated="right">
										<Image src={imageExport} size='mini' verticalAlign='middle'
											className='topbar-button-image' />
										<Label className='topbar-button-caption'>
											{t("bugreport")}
										</Label>
								</Button>
							)}
							/>
						{/*</div>*/}

						</Grid.Column>

					</Grid.Row>
				</Grid>

				<Grid doubling>
					{/* More description */}
					<Grid.Row columns={2} className='more-detail-container'>

						<Grid.Column textAlign='left' verticalAlign='middle'
							className='more-detail-description' mobile={16} tablet={9} computer={9}>
              <Segment className={pro ? 'more-detail-description-content-pro' :  'more-detail-description-content'}>
                <Label className='more-detail-description-text'>
                  {this.props.description}
                </Label>
              </Segment>
            </Grid.Column>

            <Grid.Column textAlign='left' verticalAlign='middle' mobile={16} tablet={7} computer={7}>
              {
                this.props.howToLink !== undefined && this.props.howToText !== undefined ? (
                  <Segment piled className='more-detail-how-to-content'>

                    <Grid doubling className='more-detail-how-to-wrapper-grid'>

                        <Grid.Column textAlign='left' verticalAlign='middle' width={13}>
													<a href={this.props.howToLink} target="_newtab">
	                          <Label title={this.props.information} className='more-detail-how-to-text'>
	                            { this.props.howToLink != undefined ? (
	                              <Popup content={this.props.howToLink}
	                                trigger={
																		<Image src={imageQuestion} size='mini' verticalAlign='middle'
																			className='more-detail-how-to-image' />
	                                }
	                              />
	                            ):(
	                              <div></div>
	                            )}
	                            {this.props.howToText}
	                          </Label>
													</a>
                        </Grid.Column>

                        <Grid.Column textAlign='right' verticalAlign='middle' width={2}>
                          <Icon name={"angle right"} color='grey'/>
                        </Grid.Column>

                    </Grid>

                  </Segment>
                ):(
                  <div></div>
                )
              }
            </Grid.Column>

          </Grid.Row>
					{
						this.props.pictureWeb != undefined ? (
							<Grid.Row columns={1}>
								<Grid.Column>
									<Segment>
									<Image
										src={API.resourceURL + '/upload/wimgweb/' + this.props.pictureWeb}
										centered
										size='medium'
									/>
									</Segment>
								</Grid.Column>
						</Grid.Row>
						) : (
							<div/>
						)
					}
          {/* Calculation informations */}
          <Grid.Row columns={1}>
            {
              Object.entries(this.state.groupQuestion).map((groupQuestionItem, indexes) => { // Create groups
								let questions = []

								Object.entries(groupQuestionItem[1]).map((key, Mainindex) => { // Create question / question ldc / calculation
                  let text, preentry, unit
                  if (key[1].OrText != undefined) {
                    // RETURN OR
                    if (key[1].OrText) {
                      Object.entries(key[1].OrText).map((key, Mainindex) => {
                        if (key[0] === this.props.lang) {
                          text = key[1]
                        }
                      })
                    }
                    questions.push(
											<Or
												key={Mainindex}
												text={text}
												pro={pro}
												isHidden={key[1].IsHidden}
											/>
										)
                  } else if (key[1].VariableText != undefined || key[1].VariableNum != undefined) {
                    // RETURN QUESTION LDC
                    let raz, colorBlue, information, value;

                    if (key[1].Text) {
                      Object.entries(key[1].Text).map((key, Mainindex) => {
                        if (key[0] === this.props.lang) {
                          text = key[1]
                        }
                      })
                    }
                    if (key[1].Unit) {
                      Object.entries(key[1].Unit).map((key, Mainindex) => {
                        if (key[0] === "Meter") {
                          unit = key[1]
                        }
                      })
                    }

                    if (key[1].ColorBlue) {
                      colorBlue = key[1].ColorBlue
                    }

                    if (key[1].Preentry) {
                      preentry = key[1].Preentry
										}

										if (key[1].Value) {
											value = key[1].Value;
										}

                    if (key[1].Informations) {
                      Object.entries(key[1].Informations).map((key, Mainindex) => {
                        if (key[0] === this.props.lang) {
                          information = key[1]
                        }
                      })
                    }

                    if (this.state.raz) {
                      raz = this.state.raz
                    }

                    if (this.props.configfile.calculResult != undefined &&
                      	this.props.configfile.calculResult != null) {
                      Object.entries(this.props.configfile.calculResult).map((calculResultItem, Mainindex) => {
                        if (calculResultItem[1].ID === key[1].ID &&
													 	calculResultItem[1].groupid == this.getGroupID(key[1])) {
													preentry = calculResultItem[1].variableTextValue
                        }
                      })
                    }

                    questions.push(
                      <Form key={Mainindex}>
												<QuestionLDC
													key={Mainindex}
													operandID={key[1].ID}
													groupid={this.getGroupID(key[1])}
													order={key[1].Order}
													currency={this.props.currency}
													information={information}
													colorBlue={colorBlue}
													raz={raz}
													preentry={value ? value : ((preentry === undefined) || (preentry === null)) ? '0' : preentry}
													text={((text === undefined) || (text === null)) ? '' : text}
													options={key[1].LDC}
													lang={this.props.lang}
													unit={unit}
													userUnit={this.props.unit}
													variableNum={key[1].VariableNum}
													variableText={key[1].VariableText}
													need={key[1].ErrorEmpty}
													error={key[1].Error}
													onChangeValueCallback={this.handleChangeValueOfQuestionLDC}
													isHidden={key[1].IsHidden}
													pro={this.props.pro}
													type={key[1].Type}
												/>
                      </Form>
                    )
                  }
                  else if (key[1].Condition != undefined) {

                  } else {
                    // RETURN QUESTION

                    let variable, raz, colorBlue, information, value;

                    if (key[1].Text) {
                      Object.entries(key[1].Text).map((key, Mainindex) => {
                        if (key[0] === this.props.lang) {
                          text = key[1]
                        }
                      })
                    }
                    if (key[1].Unit) {
                      Object.entries(key[1].Unit).map((key, Mainindex) => {
                        if (key[0] === "Meter") {
                          unit = key[1]
                        }
                      })
                    }

                    if (key[1].Preentry != undefined) {
                      preentry = key[1].Preentry
                    }

                    if (key[1].Variable != undefined) {
                      variable = key[1].Variable
                    }

                    if (key[1].ColorBlue) {
                      colorBlue = key[1].ColorBlue
                    }

                    if (key[1].Informations) {
                      Object.entries(key[1].Informations).map((key, Mainindex) => {
                        if (key[0] === this.props.lang) {
                          information = key[1]
                        }
                      })
										}

										if(key[1].Value) {
											value = key[1].Value;
										}

                    if (this.state.raz) {
                      raz = this.state.raz
                    }

                    let unitSend;
                    if (this.props.configfile.calculResult != undefined ||
                        this.props.configfile.calculResult != null) {
                      Object.entries(this.props.configfile.calculResult).map((key, Mainindex) => {
                        if (key[1].variable === variable) {
                          preentry = key[1].value
                          unitSend = key[1].unit
                        }
                      })
                    }
                    questions.push(
                      <Form key={Mainindex}>
												<Question
													key={Mainindex}
													operandID={key[1].ID}
													groupid={this.getGroupID(key[1])}
													order={key[1].Order}
													currency={this.props.currency}
													unitSend={unitSend}
													colorBlue={colorBlue}
													information={information}
													text={text}
													preentry={((preentry === undefined) || (preentry === null) || ((''+preentry).indexOf('%') > -1)) ? '' : preentry}
													unit={unit}
													userUnit={this.props.unit}
													variable={variable}
													raz={raz}
													need={key[1].ErrorEmpty}
													error={key[1].Error}
													onChangeValueCallback={this.handleChangeValueOfQuestion}
													onChangeUnitCallback={this.handleChangeUnitOfQuestion}D
													isHidden={key[1].IsHidden}
													value={value || ''}
												/>
                      </Form>
                    )
                  }
                })

                let calculations = []
                Object.entries(groupQuestionItem[1]).map((key, Mainindex) => {
                  let text, preentry, unit
                  if (key[1].Condition != undefined) {
                    // RETURN CALCULATION

                    let variable, result, raz, information, error;

                    if (key[1].Text) {
                      Object.entries(key[1].Text).map((key, Mainindex) => {
                        if (key[0] === this.props.lang) {
                          text = key[1]
                        }
                      })
                    }
                    if (key[1].Unit) {
                      Object.entries(key[1].Unit).map((key, Mainindex) => {
                        if (key[0] === "Meter") {
                          unit = key[1]
                        }
                      })
                    }
                    if (key[1].Variable != undefined) {
                      variable = key[1].Variable
                    }

                    let unitSend;
                    if (this.props.configfile.calculResult != undefined ||
                        this.props.configfile.calculResult != null) {
                      Object.entries(this.props.configfile.calculResult).map((key, Mainindex) => {
												if (key[1].variable === variable) {
                          result = key[1].value
                          unitSend = key[1].unit === undefined ? '' : key[1].unit
                        }
                      })
                    }

                    if (key[1].Informations) {
                      Object.entries(key[1].Informations).map((key, Mainindex) => {
                        if (key[0] === this.props.lang) {
                          information = key[1]
                        }
                      })
                    }

                    if (this.state.raz) {
                      raz = this.state.raz
                    }

										error = key[1].Error

                    calculations.push (
                      <Form key={Mainindex}>
												<Calculation
													key={Mainindex}
													operandID={key[1].ID}
													groupid={this.getGroupID(key[1])}
													order={key[1].Order}
                          currency={this.props.currency}
													break={"break"} unitSend={unitSend}
													information={information}
													condition={key[1].Condition}
													formula={key[1].Formula}
                          text={(error || (text === null) || (text === undefined)) ? '' : text}
													unit={unit}
													userUnit={this.props.unit}
													variable={variable}
													raz={raz}
													value={error ? t('error') :
																 	((result === null) || (result === undefined))
																		? '0' : result}
													error={error}
													onChangeValueCallback={this.handleChangeValueOfCalculation}
													onChangeUnitCallback={this.handleChangeUnitOfCalculation}
													isHidden={key[1].IsHidden}
												/>
                      </Form>
                    )
                  } else {
                    return null
                  }
                })

                return (
                  <Grid.Column key={indexes} columns={1}>
											{/* exist both */}
											{ questions.length != 0 && calculations.length != 0 && (
													<Segment.Group key={indexes} horizontal className='question-calculation-group'>
														<Grid doubling className='questions-container-grid'>
															<Grid.Column verticalAlign='middle' className='questions-container-column' mobile={16} tablet={11} computer={11}>
																<div className="triangle"></div>
	                              <Segment className='questions-wrapper'>
	                                {questions}
	                              </Segment>
		                          </Grid.Column>

															<Grid.Column textAlign="left" verticalAlign="middle" className='calculation-container-column' mobile={16} tablet={5} computer={5}>
																<Segment className='calculations-wrapper'>
																	{calculations}
																</Segment>
															</Grid.Column>
														</Grid>
		                    	</Segment.Group>
												)
											}

											{/* exist only questions */}
											{ questions.length != 0 && calculations.length == 0 && (
													this.createOnlyQuestionsGroupTag(questions)
												)
											}

											{/* exist only calculations */}
											{ questions.length == 0 && calculations.length != 0 && (
													this.createOnlyCalculationsGroupTag(calculations)
												)
											}

                  </Grid.Column>
                )
              })
            }
            {
              this.props.configfile.calculError ? (
                <Grid.Column>
                  <Segment inverted color='red' tertiary style={errorMessageLogin}>
                    <Icon name={"remove circle"} style={{height: 'auto'}}/>{this.props.configfile.atlError}
                    {t('errorData')}
                  </Segment>
                </Grid.Column>
              ):(
                <div></div>
              )
            }

            {/* Submit buttons */}
            <Grid.Row centered columns={3} className='button-group'>
              <Grid doubling centered>
                { this.props.raz ? (
                  <Grid.Row columns={3}>
                    <Grid.Column mobile={8} tablet={5} computer={5} verticalAlign={"middle"} >
                      <Button fluid size='massive' id="greyBtn" className="buttonIcon" onClick={(e) => this.handleRaz(e)}>
                        <Icon circular name='refresh' size='small' style={{ boxShadow:'0 0 0 0.1em rgba(255,255,255,1) inset' }} />
                        {t('RAZ')}
                      </Button>
                    </Grid.Column>
                    <Grid.Column mobile={8} tablet={5} computer={5} verticalAlign={"middle"}>
                      <Button id={'calcul'} fluid size='massive'
												className={ pro ? 'yelloBtn': 'blueBtn'}
                        onClick={(e) => this.handleCalcul(e, this.state.groupQuestion, true)}
                        loading={this.state.modal_loader ? ( true ):( false )}
												disabled= {(pro && !this.state.isPro) ? (true):(false)}
											>
												{t('calcul')}
												{
												(pro && !this.state.isPro) ? (
													<Icon
														name='lock'
														className='proLock'
													/>
												) : (
													<div> </div>
												)
											}
                      </Button>

                      <Button fluid className={ 'calculation-button-not-register blueBtn'}
											 	id={'calculApp'} fluid size='massive'
												onClick={(e) => this.handleCalcul(e, this.state.groupQuestion, false)}>
                        {t('calcul')}
                      </Button>
                      <ModalLoader />
                    </Grid.Column>

                    { this.props.addToListCondition ? (
                        <Grid.Column mobile={16} tablet={6} computer={6} verticalAlign={"middle"}>
                          <Button fluid size='massive' id={"EnterAddList"} className="buttonIcon" basic style={{height: '70px', padding: '.78571429em'}}
                            onClick={(e) => this.handleAddToList(e)}>
                            <Icon name='add to cart'/>
                            {t('atl')}
                            <Icon name={"angle right"} />
                          </Button>
                          <ModalAddToList lang={this.state.configFileLang} />
                        </Grid.Column>
                      ):(
                        <div></div>
                      )
                    }
                  </Grid.Row>
                ):(
                  <div>
                  </div>
                )}
              </Grid>
            </Grid.Row>
          </Grid.Row>
        </Grid>
      </div>
    )
  }
}

const Work = connect(mapStateToProps, mapActionToProps)(ConnectedWork);
export default translate("Work")(Work);



// WEBPACK FOOTER //
// ./src/components/Protected/Travaux/Work.jsx